import type {
  PartThumbnailImageQueryKey,
  UsePartThumbnailImageParams,
} from '../types';

export const getPartThumbnailImageQueryKey = (
  params: UsePartThumbnailImageParams,
): PartThumbnailImageQueryKey => ['parts', 'partThumbnailImage', params];
